import axios from "axios"
axios.defaults.baseURL = process.env.VUE_APP_API;

export default {
  state: () => ({
    stats: [],
  }),
  getters: {
    getStats: (state) => state.stats,
  },
  mutations: {
    setStats(state, resultStats) {
      state.stats = resultStats
    },
  },
  actions: {
    /** Fetch admin basic info */
    async fetchStats({ commit }) {
      const stats = (await axios.get(`${axios.defaults.baseURL}admin/stats`)).data
      commit("setStats", stats)
    },
  },
}
